import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { AnnouncementList_announcements_edges_node } from "@saleor/announcements/types/AnnouncementList";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import AnnouncementThumbmailList from "../AnnouncementThumbmailList";
import {
  AnnouncementFilterKeys,
  AnnouncementListUrlFiltersOpts,
  createFilterStructure
} from "./filters";

export interface AnnouncementTableProps
  extends PageListProps,
    TabPageProps,
    ListActions,
    FilterPageProps<AnnouncementFilterKeys, AnnouncementListUrlFiltersOpts> {
  announcements: AnnouncementList_announcements_edges_node[];
}

export const AnnouncementListPage: React.FC<AnnouncementTableProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  currencySymbol,
  onAdd,
  ...listProps
}) => {
  const intl = useIntl();
  const breadcrumbDirectory = [
    {
      name: "Announcements"
    }
  ];
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={intl.formatMessage(sectionNames.announcements)}>
        <Button
          color="primary"
          variant="contained"
          onClick={onAdd}
          id="createAnnouncementBtn"
        >
          <FormattedMessage
            defaultMessage="Create announcement"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          tabs={tabs}
          filterStructure={structure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Announcements"
          })}
          initialSearch={initialSearch}
          onSearchChange={onSearchChange}
          onFilterChange={onFilterChange}
          onAll={onAll}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <AnnouncementThumbmailList {...listProps} />
      </Card>
    </Container>
  );
};
AnnouncementListPage.displayName = "AnnouncementListPage";
export default AnnouncementListPage;
